import { AfterViewInit, Component, OnInit } from '@angular/core';
import { PageTitleHelper } from 'src/app/helpers/PageTitleHelper';
import { LoggedInService } from 'src/app/services/auth/loggedin.service';
import { DinamicTitleService } from 'src/app/services/title/dinamic-title.service';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  userName: string = '';
  title = '';
  constructor(
    private titleService : DinamicTitleService,
    private loggedinService: LoggedInService
  ) { }


  ngOnInit(): void {
    this.getTitle();
    this.getUserName();
  }

  getTitle(): void {
    this.titleService.data$.subscribe(res => {
      this.title = res;
    });
  }

  getUserName(): void {
    this.loggedinService.tokenContent$.subscribe(
      (response) => {
        this.userName = response.nomeUsuario
      }
    )
  }

}
